module.exports = __webpack_public_path__ + "static/media/eu_verdadeiro_3.81fd8c66.jpg";